import { Box, FormControlLabel, Switch } from '@mui/material';
import { IconMoon } from '@tabler/icons-react';
import { useAppearance } from 'src/theme/appearance';

export default function AppearancePicker() {
    const mode = useAppearance((s) => s.mode);
    const setMode = useAppearance((s) => s.setMode);
    return (
        <Box sx={{ px: 1.5, py: 1.2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <IconMoon size={19} />
            <FormControlLabel
                label="Тёмная тема"
                labelPlacement="start"
                sx={{ m: 0, flex: 1, justifyContent: 'space-between', '.MuiTypography-root': { fontSize: 14 } }}
                control={
                    <Switch
                        size="small"
                        checked={mode === 'dark'}
                        onChange={(_, checked) => setMode(checked ? 'dark' : 'light')}
                    />
                }
            />
        </Box>
    );
}
